@if (status === NetworkStatus.offline) {
<mat-icon svgIcon="wifi_off"></mat-icon>
}
